import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Button, Dialog } from 'ui';
import { ModalBackdrop } from 'ui/ModalBackdrop';

import { AuthContext, AuthError } from 'app/auth';
import { logButtonEvent } from 'app/amplitude';

import { YourDetails } from './screens';
import styles from './Register.module.scss';
import { usePageViewTracker } from 'hooks';
import { ReactComponent as WhitePebbleLogo } from './pebbleLogoWhite.svg';
import listingsPreview from './listingsPreview.png';
import { BackButton } from 'app/components';
import { Link } from 'react-router-dom';

export const Register = () => {
  const history = useHistory();
  const location = useLocation();

  const [formData, setFormData] = useState({
    mobileNumber: '',
    password: '',
    termsOfUse: false,
    privacyPolicy: false,
  });
  const [showError, setShowError] = useState(false);
  const authContext = useContext(AuthContext);

  usePageViewTracker('register');

  /**
   * Performs a user registration with the collected formData.
   */
  const register = async () => {
    try {
      logButtonEvent('register_terms_and_conditions');
      await authContext.signup(formData.mobileNumber, formData.password);

      history.push({
        pathname: '/verify',
        search: location?.search,
      });
    } catch (error) {
      if (error instanceof AuthError && error.errorCode === 'UsernameExistsException') {
        setShowError(true);
      } else {
        history.push('/error', { from: '/register' });
      }
    }
  };

  return (
    <>
      <div className={styles.pageContainer}>
        <div className={styles.mobileLinksWrapper}>
          <BackButton useHistoryBack={useHistory} />
          <Link className={styles.loginLink} to={{ pathname: '/login', search: location?.search }}>
            Log in
          </Link>
        </div>
        <div className={styles.illustrationContainer}>
          <WhitePebbleLogo />
          <div className={styles.headerContainer}>
            <h3 className={styles.header}>Welcome to Pebble 👋</h3>
            <p className={styles.subHeader}>All your bookings made easy</p>
            <div className={styles.illustration}>
              <img src={listingsPreview} alt="Platform preview" />
            </div>
          </div>
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.desktopLinksWrapper}>
            <BackButton useHistoryBack={useHistory} />
            <Link
              className={styles.loginLink}
              to={{ pathname: '/login', search: location?.search }}
            >
              Log in
            </Link>
          </div>
          <div className={styles.detailsContainer}>
            <YourDetails register={register} formData={formData} setFormData={setFormData} />
          </div>
        </div>
      </div>

      <Dialog
        title="Registration issue"
        isVisible={showError}
        onClose={() => setShowError(false)}
        menu={
          <Button href="/forgot-password" expand>
            Reset password
          </Button>
        }
      >
        <p>
          We’re sorry, we were unable to create your account. If you already registered and forgot
          your password you can reset it below, or contact{' '}
          <a href="mailto:support@bookpebble.co.uk" className={styles.supportLink}>
            support@bookpebble.co.uk
          </a>
        </p>
      </Dialog>

      <ModalBackdrop isVisible={showError} />
    </>
  );
};
